export default __webpack_public_path__ + "static/media/02-Nar-CH-white.d3617ac7.png";